module.exports = __webpack_public_path__ + "media/images/avatar/19-1259187e0b519263b109a38027f51bb5.svg";